const teamMembers = document.querySelectorAll(".js-team-member_has-bio");

teamMembers.forEach((member) => {
	let back = member.querySelector(".team-member__back");

	if (!back) {
		return;
	}

	let openBtn = member.querySelector(".js-team-member__button_open-bio");

	openBtn.onclick = () => {
		back.classList.add("team-member__back_fadein");
		back.classList.remove("team-member__back_fadeout");
	};

	let closeBtn = member.querySelector(".js-team-member__button_close-bio");

	closeBtn.onclick = () => {
		back.classList.remove("team-member__back_fadein");
		back.classList.add("team-member__back_fadeout");
	};
});
